import { InjectionKey, Ref } from 'vue';
import type { PdfEngine } from '@elhalawany/models';

export interface PdfEngineContextState {
  engine: Ref<PdfEngine | null>;
  isLoading: Ref<boolean>;
  error: Ref<Error | null>;
}

export const pdfEngineKey: InjectionKey<PdfEngineContextState> = Symbol('pdfEngineKey');
